
import { defineComponent } from 'vue'

import formatPriceToTenge from '@/modern/helpers/formatPriceToTenge'

export default defineComponent({
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        total: {
            type: Number,
            default: 0
        },
        expenses: {
            type: String,
            default: 0
        },
        waiting: {
            type: Number,
            default: 0
        },
        paid: {
            type: Number,
            default: 0
        }
    },
    setup() {
        return {
            formatPriceToTenge
        }
    }
})
